import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { 
  FiMonitor, FiCoffee, FiShoppingBag, FiTruck, 
  FiPhoneCall, FiSun, FiHome, FiTool, FiArrowRight
} from 'react-icons/fi';

const Jobbereiche = () => {
  const jobs = [
    { 
      id: 'aushilfe', title: 'Allgemeine Aushilfe', icon: FiHome, 
      desc: 'Für Verkauf, Lager, Büro, Events, Gastronomie oder einfache Unterstützung im Betrieb.',
      tags: ['Flexibel', 'Ohne Vorerfahrung']
    },
    { 
      id: 'buero', title: 'Büro & Home Office', icon: FiMonitor, 
      desc: 'Einfache Bürotätigkeiten, Datenerfassung, Terminvereinbarung, Kundenservice, E-Mail-Bearbeitung.',
      tags: ['Home Office möglich', 'PC-Kenntnisse']
    },
    { 
      id: 'reinigung', title: 'Reinigung', icon: FiSun, 
      desc: 'Reinigung von Büros, Praxen, Treppenhäusern, Gewerbeflächen oder privaten Haushalten.',
      tags: ['Früh/Spät', 'Körperliche Arbeit']
    },
    { 
      id: 'callcenter', title: 'Callagent & Telefonie', icon: FiPhoneCall, 
      desc: 'Telefonische Kundenbetreuung, Terminvereinbarung, Inbound, Outbound, Service-Hotline.',
      tags: ['Kommunikativ', 'Home Office möglich']
    },
    { 
      id: 'verkauf', title: 'Verkauf & Einzelhandel', icon: FiShoppingBag, 
      desc: 'Kassentätigkeit, Warenverräumung, Kundenberatung, Unterstützung auf der Fläche.',
      tags: ['Kundenkontakt', 'Schichtdienst']
    },
    { 
      id: 'gastro', title: 'Gastronomie & Service', icon: FiCoffee, 
      desc: 'Servicehilfe, Küchenhilfe, Spülkraft, Barhilfe, Eventservice oder Unterstützung in Cafés.',
      tags: ['Wochenende', 'Trinkgeld']
    },
    { 
      id: 'logistik', title: 'Lager & Logistik', icon: FiTruck, 
      desc: 'Kommissionierung, Verpackung, Versand, Warensortierung und einfache Lagerarbeiten.',
      tags: ['Körperliche Arbeit', 'Schichtdienst']
    },
    { 
      id: 'promotion', title: 'Promotion & Events', icon: FiTool, 
      desc: 'Flyerverteilung, Messehilfe, Eventbetreuung, Sampling und Promotionaktionen.',
      tags: ['Flexibel', 'Wochenende']
    },
  ];

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-bold mb-6">Unsere Jobbereiche</h1>
          <p className="text-lg text-slate-600">
            Wir vermitteln Jobs für verschiedene Lebenssituationen. Oft sind keine langen Vorerfahrungen nötig – Motivation und Zuverlässigkeit zählen mehr. Finde den Bereich, der zu dir passt.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {jobs.map((job) => (
            <div key={job.id} className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow flex flex-col">
              <div className="w-14 h-14 bg-teal-50 text-teal-600 rounded-xl flex items-center justify-center mb-6">
                <SafeIcon icon={job.icon} className="text-2xl" />
              </div>
              <h2 className="text-xl font-bold mb-3">{job.title}</h2>
              <p className="text-slate-600 mb-6 flex-grow">{job.desc}</p>
              
              <div className="flex flex-wrap gap-2 mb-6">
                {job.tags.map(tag => (
                  <span key={tag} className="text-xs font-medium bg-slate-100 text-slate-600 px-2.5 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>

              <Link to="/bewerber" className="text-teal-600 font-medium hover:text-teal-700 flex items-center group mt-auto">
                Für diesen Bereich bewerben
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-slate-900 rounded-3xl p-10 text-center text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Dein Bereich ist nicht dabei?</h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            Kein Problem. Bewirb dich einfach initiativ und gib an, was du gerne machen möchtest. Wir haben oft auch individuelle Anfragen von Unternehmen.
          </p>
          <Link to="/bewerber" className="btn-primary bg-teal-500 hover:bg-teal-400">
            Initiativ bewerben
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Jobbereiche;